import '../styles/home.scss';
import ProfileLinks from "../components/ProfileLinks";

function About() {
  return (
    <section
      className="about"
    >

      <div className="about-info">
        <h1 className="home-project-title about-title">UX Engineer · Developer · Strategist</h1>
        <p>Leveraging a background in software engineering and a Master’s focus in HCI, I specialize in analyzing user behavior to drive strategic design.
          My mission is simple: <strong>build interfaces that aren't just functional, but validated, accessible, and engineered to scale.</strong>
        </p>

        <ProfileLinks />

        <div className="current">
          <div className="about-box">
            <h1 className="home-project-title">Lead Visual Designer & Web Developer | Delicate Coffee Roasters</h1>
            <p>As the sole creative force behind Delicate Coffee Roasters, I own the entire brand lifecycle—from
              digital screens to physical shelf presence. I developed and maintain the company website, utilizing
              Figma to design intuitive digital experiences that pair seamlessly with our weekly coffee drops. <br></br><br></br>On the brand side,
              I illustrate and vectorize our recurring mascot for every drop, curate tasting-note-driven color palettes,
              and create custom packaging, art prints, and marketing collateral using hands-on print production.
              I bridge the gap between digital UX, physical packaging, and multi-channel marketing to build
              an unforgettable, cohesive customer experience every single week.</p>
          </div>
        </div>
      </div>


      <div className="education">
        <div
          className="edu1"
          role="group"
          aria-labelledby="devry-title"
        >
          <h1 className="home-project-title">Devry University</h1>
          <h3>Bachelor of Science in Software Development</h3>
          <p>Summa Cum Laude</p>
          <p>Graduated 2024</p>
        </div>

        <div
          className="edu2"
          role="group"
          aria-labelledby="depaul-title"
        >
          <h1 className="home-project-title">DePaul University</h1>
          <h3>Master of Science in Human-Computer Interaction</h3>
          <p>Dean's List</p>
          <p>Expected Graduation: 2027</p>
        </div>
      </div>




    </section>
  );
}

export default About;
